/**
 * Created by jonas on 2021-03-04.
 */
import {DasUBootSymbol, DasUBootSymbolStates} from "../DasUBootSymbol";
import {gsap} from "gsap";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootReel} from "../DasUBootReel";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {DasUBootStatics} from "../../utils/DasUBootStatics";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {SpineGSAPWrapper} from "../../../core/animation/SpineGSAPWrapper";

export function isStackedWildSymbol(value:any):value is StackedWildSymbol {
    return value.symbolName === "W4";
}

export class StackedWildSymbol extends DasUBootSymbol {
    isSplit:boolean = false;

    constructor(reel:DasUBootReel, symbolName:string) {
        super(reel, symbolName);
        this.sprite.position.set(72, -144);
        this.sprite.anchor.set(0.5, 0.5);

        this._whiteOverlay.height = 144 * 4;
        this._whiteOverlay.anchor.set(0.5, 0.5);

        this.frame.pivot.set(72, 288);
        this.frame.height = 144 * 4;
    }


    public getStateAnimation(state:DasUBootSymbolStates):gsap.core.Timeline {
        let tl:gsap.core.Timeline;

        switch (state) {
            case DasUBootSymbolStates.LANDING:
                tl = super.getStateAnimation(state);
                tl.add(() => DasUBoot.soundPlayer.playSingleSound(DasUBootSound.WILD_LANDING));
                tl.add(() => {DasUBoot.reelView.getLandingShake(false).play(0)});
                break;
            default:
                tl = super.getStateAnimation(state);

        }

        this._stateAnimation = tl;
        return tl;
    }


    public nudge(steps:number) {
        //this.nudgeText.text = ""+steps;
    }

    public nudgeComplete() {
        this.isSplit = true;
        const spine = DasUBoot.graphicsPool.getSpinePool(DasUBootGameAssets.STACKED_WILD_SPINE).withdraw();
        spine.position.set(DasUBootStatics.symbolWidth * 0.5, DasUBootStatics.symbolHeight * -1);

        const tl = gsap.timeline();
        tl.add(() => {
            this.moveToWinLayer();
            this.view.addChild(spine);
            spine.updateTransform();
            DasUBoot.soundPlayer.playSingleSound(DasUBootSound.WILD_NUDGE_TRANSFORM)
        });

        tl.add(SpineGSAPWrapper.createTimeline(spine, 0, "SplittingTheNudgingWilds"));

        tl.add(() => {
            SpineGSAPWrapper.clearAnimation(spine, 0);
            this.view.removeChild(spine);
            DasUBoot.graphicsPool.getSpinePool(DasUBootGameAssets.STACKED_WILD_SPINE).deposit(spine);
        });

        return tl;
    }

}